export const TomaticLogo = ({ className = "" }: { className?: string }) => (
  <div className={`flex flex-col items-center justify-center select-none text-center ${className}`}>
    <h1 className="text-3xl font-black tracking-tight text-foreground uppercase mb-2">
      TOMATIC<sup className="text-[10px] font-normal align-super">TM</sup>
    </h1>

    <p className="text-sm text-muted-foreground mb-3">
      {__APP_VERSION__} · Build {__BUILD_NUMBER__}
    </p>

    <div className="text-xs text-muted-foreground space-y-0.5">
      <p>Built with TOMATIC Engine</p>
      <p>Logistics Automation Platform</p>
    </div>
  </div>
)
